import { useFormContext } from "react-hook-form";
import { matchingPrincipalName } from "../../../../../shared/bond/principal";
import { BondSummary as RequestBondSummary } from "../../../../request/create/steps/bond/BondSummary";
import type { CombinedFormData } from "../../schema";

export const BondSummary = () => {
	const { getValues } = useFormContext<CombinedFormData>();
	const { account, quote } = getValues();

	return (
		<RequestBondSummary
			includeCommercialFields
			principalName={
				matchingPrincipalName({
					companies: account?.details?.companies,
					principalName: quote?.principal?.name,
				}) ?? null
			}
		/>
	);
};
